
const entries = [
  {
    id: "d412ec9d-1ddb-455f-98ec-3cd1b4e3b561",
    date: "2025-08-01",
    title: "These turquoise waters.",
    location: "Lanikai Beach",
    country: "Hawaii, USA",
    description:
    "A pristine beach with crystal-clear turquoise waters and soft white sand, perfect for a relaxing getaway.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "a1b2c3d4-e5f6-7890-abcd-1234567890ef",
    date: "2024-08-02",
    title: "We woke up early to catch the light.",
    location: "Santorini",
    country: "Greece",
    description:
    "A picturesque island known for its stunning sunrise views, whitewashed buildings, and blue-domed churches.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "b2c3d4e5-f6a7-8901-bcde-2345678901fa",
    date: "2024-08-03",
    title: "A serene sunset by the bay.",
    location: "Halong Bay",
    country: "Vietnam",
    description:
    "A UNESCO World Heritage Site featuring emerald waters and thousands of towering limestone islands.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "c3d4e5f6-a7b8-9012-cdef-3456789012fb",
    date: "2023-10-04",
    title: "Exploring the ancient ruins.",
    location: "Machu Picchu",
    country: "Peru",
    description:
    "An ancient Incan city set high in the Andes Mountains, renowned for its sophisticated dry-stone construction.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "d4e5f6a7-b8c9-0123-def0-4567890123fc",
    date: "2024-10-05",
    title: "A walk through the cherry blossoms.",
    location: "Tokyo",
    country: "Japan",
    description:
    "Experience the beauty of cherry blossoms in full bloom in the bustling yet serene parks of Tokyo.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "e5f6a7b8-c9d0-1234-ef01-5678901234fd",
    date: "2024-10-06",
    title: "The bustling streets of the city.",
    location: "Hong Kong",
    country: "China",
    description:
    "A vibrant city known for its skyscrapers, bustling markets, and stunning harbor views.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "f6a7b8c9-d0e1-2345-f012-6789012345fe",
    date: "2024-10-07",
    title: "A quiet day by the lake.",
    location: "Lake Bled",
    country: "Slovenia",
    description:
    "A picturesque lake surrounded by mountains, featuring a charming island with a church.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "a7b8c9d0-e1f2-3456-0123-7890123456ff",
    date: "2024-08-08",
    title: "Hiking through the mountains.",
    location: "Banff National Park",
    country: "Canada",
    description:
    "A stunning national park with majestic mountains, turquoise lakes, and abundant wildlife.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "b8c9d0e1-f2a3-4567-1234-8901234567fa",
    date: "2024-08-09",
    title: "The vibrant colors of the market.",
    location: "Istanbul",
    country: "Turkey",
    description:
    "A city where East meets West, known for its vibrant bazaars, rich history, and stunning architecture.",
    image: "https://picsum.photos/{width}/{height}",
  },
  {
    id: "c9d0e1f2-a3b4-5678-2345-9012345678fb",
    date: "2024-08-10",
    title: "A day at the theme park.",
    location: "Disneyland Paris",
    country: "France",
    description:
    "A magical theme park offering thrilling rides, enchanting shows, and beloved Disney characters.",
    image: "https://picsum.photos/{width}/{height}",
  },
]

  export default entries;